import { Observable } from 'rxjs';
import { XrtRegisterRequest, XrtConnectResponse } from './hub-settings.model';

export interface IXrtLiveDocumentsService {
  connect(registerRequest: XrtRegisterRequest): Observable<XrtConnectResponse>;
  disconnect(filterHash: string, subscribeResponse: XrtConnectResponse): Observable<any>;
}
